<template>

    <div>
        <div v-if="componentLoading">
            <p class="text-2xl text-orange-500 mt-6 ml-6">Loading...</p>
        </div>

        <!-- BEGIN SECTION MODULE -->
        <div class="w-full bg-theme-level4 border-b border-theme-level2">
            <div id="sectionHeader" class="pl-4 py-4 pr-2 border-b border-theme-level2 flex flex-row items-center justify-between">
                <h2 class="text-theme-discrete font-bold text-base" v-text="theSectionTitle" @click="showCategory"></h2>
                <div id="section-controls">
                    <!--<i id="section-info-config" class="material-icons mr-2 cursor-pointer w-4 h-4 text-theme-muted hover:text-theme-discrete" style="font-size: 24px;">more_vert</i>-->
                    <!--<i id="section-info-control" class="material-icons mr-2 cursor-pointer w-4 h-4 text-theme-xmuted hover:text-theme-muted" style="font-size: 20px;">info_outline</i>
                    <i id="section-config-control" class="material-icons mr-2 cursor-pointer w-4 h-4 text-theme-xmuted hover:text-theme-muted" style="font-size: 20px;">highlight_off</i>-->
                </div>
            </div>
            <!-- BEGIN SECTION CONTENT -->
            <div id="mobile-section-content" class="mobile-section-container bg-theme-level3 text-theme-main">

                <div class="mobile-hs mobile-full scrolling-touch">

                    <content-module-mobile-small
                        v-if="firstContent"
                        :content="firstContent"
                        :currentlocale="currentlocale"
                        :legacy="firstContent.legacy"
                        :default_thumbnail="default_thumbnail"
                        class="shadow-lg border-4 border-theme-level1"
                    ></content-module-mobile-small>

                    <content-module-mobile-small
                        v-for="(contentPiece, index) in contentPayload"
                        v-if="index <= piecesToShow"
                        v-bind:key="contentPiece.id"
                        :content="contentPiece"
                        :currentlocale="currentlocale"
                        :legacy="contentPiece.legacy"
                        :default_thumbnail="default_thumbnail"
                        :style="{'grid-col-start: 1': index % 2 === 0}"
                    ></content-module-mobile-small>

                </div>

            <!-- END SECTION CONTENT -->
            </div>

        <!-- END SECTION MODULE -->
        </div>

    </div>

</template>

<script>

    export default {

        data() {
            return {
                componentLoading: true,
                publish_date: '22/03/2020 24:58',
                contentPayload: '',
                firstContent: ''
            }
        },

        props: [
            'filter',
            'sectiontitle_es',
            'sectiontitle_en',
            'currentlocale',
            'contentCount',
            'default_thumbnail'
        ],

        computed: {

            theSectionTitle() {
                return this.currentlocale==='es' ? this.sectiontitle_es : this.sectiontitle_en;
            },

            piecesToShow() {
                return this.contentCount==='0' ? 1000 : this.contentCount;
            }

        },

        methods: {

            showCategory() {
                window.location = '/' + this.currentlocale + '/category/' + this.filter + '/' + this.sectiontitle_es + '/' + this.sectiontitle_en
            }

        },

        mounted() {
            this.componentLoading = false;
            console.log('A MobileContentSection module was mounted.');
            // Event.fire('closeSidebar');
        },

        created() {

            this.componentLoading = true;

            console.log('Getting data for a SECTION component...');

            if(this.contentCount > 0) {

                axios.get('/api/mobile/filter/category/' + this.filter + '/' + this.currentlocale)
                    .then(response => {
                        console.log('Server Responded well... moving on.');
                        let tmpHolder = response.data;
                        this.contentPayload = tmpHolder[0];
                        this.firstContent = tmpHolder[1];
                        this.componentLoading = false;
                        console.log('DONE with data for section');
                    })
                    .catch(error => {
                        this.componentLoading = false;
                        console.log('SERVER ERROR!! --> ' + JSON.stringify(error));
                    });
            }
        },

    }

</script>


<style>

    :root {
        --gutter: 10px;
    }

    .mobile-section-container {
        padding-top: var(--gutter);
        padding-bottom: var(--gutter);
        display: grid;
        grid-gap: var(--gutter) 0;
        grid-template-columns: var(--gutter) 1fr var(--gutter);
        align-content: start;
    }

    .mobile-section-container > * {
        grid-column: 2 / -2;
    }

    .mobile-section-container > .mobile-full {
        grid-column: 1 / -1;
    }

    .mobile-hs {
        display: grid;
        grid-gap: var(--gutter);
        grid-template-columns: 10px;
        grid-template-rows: minmax(280px, 1fr);
        grid-auto-flow: column;
        /*grid-auto-columns: calc(50% - var(--gutter) * 2);*/
        grid-auto-columns: calc(280px - var(--gutter) * 2);

        overflow-x: scroll;
        scroll-snap-type: x proximity;
        padding-bottom: calc(.75 * var(--gutter));
        margin-bottom: calc(-.25 * var(--gutter));
    }

    .mobile-hs:before,
    .mobile-hs:after {
        content: '';
        width: 10px;
    }

    /* UP TO HERE **/



    .mobile-section-container {
        overflow-y: scroll;
    }



    /*.mobile-hs > li,
    .mobile-item {
        scroll-snap-align: center;
        !*padding: calc(var(--gutter) / 2 * 1.5);*!
        display: flex;
        flex-direction: column;
        justify-content: start;
        !*align-items: center;*!
        background: #fff;
        border-radius: 8px;
        overflow: hidden;
    }*/

</style>
